module.exports = __webpack_public_path__ + "img/restaurant-table-plan.2fe06f3c.svg";